import React from 'react';

import { ModalBody, ModalDesktopTitle, ModalWrapper } from './Modal.styles';
import { ModalProps } from './Modal.types';

export const Modal = ({
  width,
  children,
  name,
  parentRef = null,
  toolsRenderer = () => null,
  breakpoint = 'md',
  ...rest
}: ModalProps) => {
  return (
    <ModalWrapper
      width={width}
      name={name}
      parenRef={parentRef}
      toolsRenderer={toolsRenderer}
      breakpoint={breakpoint}
      {...rest}
    >
      <ModalDesktopTitle>{name}</ModalDesktopTitle>
      {children}
    </ModalWrapper>
  );
};

Modal.Body = ModalBody;
